<template>
  <div class="description-container">
    <div v-if="imagePath" class="illustration-container">
      <img :src="mdAndUp ? imagePath : imagePathMobile" :alt="imageAlt" class="illustration" />
    </div>
    <div class="description-text">
      {{ description }}
    </div>
  </div>
</template>

<script setup>
import { useDisplay } from "vuetify";

const { mdAndUp } = useDisplay();

defineProps({
  description: {
    type: String,
    required: true,
  },
  imagePath: {
    type: String,
    default: null,
  },
  imagePathMobile: {
    type: String,
    default: null,
  },
  imageAlt: {
    type: String,
    default: "Tool illustration",
  },
});
</script>

<style lang="scss" scoped>
@import "./../../../scss/form.scss";
.description-container {
  display: flex;
  align-items: stretch;
  color: var(--knittable-lav-darker);
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}

.app-sm-and-down .description-container {
  margin-top: 0.5rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  flex-direction: column; // Stack vertically on small screens
}

.description-text {
  @include paragraphMediumRegular;
  flex: 1;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  background-color: var(--knittable-lav-light);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(0.75rem, 2vw, 1.5rem); // Responsive padding
  min-width: 0; // Allows text to wrap properly
  max-width: 100%; // Ensures text doesn't overflow
}

.app-sm-and-down .description-text {
  border-top-right-radius: 0;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  border-top-left-radius: 0;
  padding: 1rem;
}

.illustration-container {
  flex: 0 0 auto;
  width: 250px;
  display: flex;
  align-items: flex-end;
}

.app-sm-and-down .illustration-container {
  width: 100%;
}

.illustration {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}

.app-sm-and-down .illustration {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
</style>
